<template>
  <div class="uk-container">
    <h2 class="uk-heading-small uk-text-center uk-heading-divider">
      Start a New Project
    </h2>
    <div class="uk-child-width-1-2@m uk-grid-small uk-grid-match" uk-grid>
      <div>
        <div class="uk-card uk-card-default uk-card-body">
          <h3 class="uk-card-title">Organizations</h3>
          <p>
            Companies, organizations, and groups using logos and company colors.
          </p>
          <button class="uk-button uk-button-primary uk-width-1-1">
            Start an Organization Design
          </button>
        </div>
      </div>
      <div>
        <div class="uk-card uk-card-default uk-card-body">
          <h3 class="uk-card-title">Weddings</h3>
          <p>
            Custom wedding designs with the ability to match colors from
            dressmakers.
          </p>
          <button class="uk-button uk-button-primary uk-width-1-1">
            Start a Wedding Design
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "NewProject",
  components: { draggable },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style type="text/css">
.grabbable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NewProject.vue